<template>
  <div>
    <div class="copyToBoard">
      <span id="copyBtn" :data-clipboard-text="value" data-clipboard-action="copy"  @click="copyValue">点击进入微信</span>
      <br>
      <br>
      <span>{{ this.$store.state.tabs[0].value }} </span>
    </div>
    <div class="welcome">
      <img src="../../static/assets/img/logo.png" width="252" height="82"  alt="西雅图桃桃高端私人定制">
      <div class="comstr">桃桃欢迎您的光临</div>
      <div>TAOTAO Thanks for <br> your coming</div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  name: "copyOpenWC",
  data() {
    return {
      value:this.$store.state.tabs[0].value
    };
  },
  methods: {
    // copyToBoard() {
    //   this.$copyText(this.message).then((e) => {
    //     console.log(this.message);
    //     console.log(e);
    //     this.$createToast({
    //       txt: '微信昵称已复制',
    //       type: 'txt',
    //     }).show();
    //     setTimeout(() => {
    //       this.goWxchat();
    //     }, 1000);
    //   }, (e) => {
    //     console.log(e);
    //   });
    // },
    goWxchat() {
      window.location.href = 'weixin://';
    },
    copyValue () {
      let th = this;
      var clipboard = new Clipboard('#copyBtn')
      clipboard.on('success', e => {
        th.$notify.success('复制成功')
        //  释放内存
        clipboard.destroy()
        setTimeout(() => {
          this.goWxchat();
        }, 1000);
      })
      clipboard.on('error', e =>{
        // 不支持复制
        th.$notify.error('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
      })
    },
  },
};
</script>

<style scoped>
#copyBtn{padding: 0.6rem 1.5rem;background-color: #908e8f; font-weight: bold; border-radius: 0.6rem;}
.copyToBoard{
  background-color: black;
  padding-top: 1rem;
}
.copyToBoard{
  font-size: 1.5rem;
  color: #cfcfcf;
}
.welcome{
  padding: 1.5rem 0rem;
  color: white;
  background-color: #908e8f;
}
.welcome div{
  padding: 0.5rem 0rem 0.5rem 0rem;
  font-size: 2rem;
  font-weight: bold;
  /*font-family: Impact, fantasy;*/
  /*font-family: Arial, Helvetica, sans-serif;*/
  /*font-family: Brush Script MT, cursive;*/
  /*font-family:Courier New, Consolas, monospace;*/
  font-family:Times New Roman, Georgia, serif;
  /*font-family: MyFont, sans-serif;*/
  /*font-family: "Segoe UI", "Lucida Grande", Helvetica, Arial, "Microsoft YaHei";*/
}
@font-face {
  font-family: MyFont;
  src: url(../assets/font/zxf.ttf) format('truetype');
}
.welcome div.comstr{
  letter-spacing: 0.2rem;
  font-family: MyFont, sans-serif;
  font-size: 2.6rem;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/copyOpenWC.vue